import {combineReducers} from "redux";
import UserReducer from "./userReducer";

const RootReducer = combineReducers({
  // Aquí puedes importar y combinar tus reducers individuales
  user: UserReducer,
});

export default RootReducer;
